/**
 * Web 日志常量定义
 *
 * @description Web 端错误和性能日志的常量映射
 * @module @bayes-mes/shared/types/web-logs
 * @author YSFL Team
 * @date 2026-01-24
 */

import { WebErrorLevel, WebErrorType, WebMetricType } from './enums';

// ============================================================================
// 错误类型标签
// ============================================================================

/** 错误类型标签映射 */
export const WEB_ERROR_TYPE_LABELS: Record<WebErrorType | string, string> = {
  [WebErrorType.JS_ERROR]: 'JS运行时错误',
  [WebErrorType.VUE_ERROR]: 'Vue组件错误',
  [WebErrorType.PROMISE_ERROR]: 'Promise拒绝',
  [WebErrorType.RESOURCE_ERROR]: '资源加载错误',
  [WebErrorType.API_ERROR]: 'API请求错误',
};

/** 错误类型选项（用于下拉框） */
export const WEB_ERROR_TYPE_OPTIONS = Object.entries(WEB_ERROR_TYPE_LABELS).map(
  ([value, label]) => ({
    value,
    label,
  }),
);

// ============================================================================
// 错误级别标签
// ============================================================================

/** 错误级别标签映射 */
export const WEB_ERROR_LEVEL_LABELS: Record<WebErrorLevel | string, string> = {
  [WebErrorLevel.FATAL]: '致命',
  [WebErrorLevel.ERROR]: '错误',
  [WebErrorLevel.WARNING]: '警告',
  [WebErrorLevel.INFO]: '信息',
};

/** 错误级别颜色映射 */
export const WEB_ERROR_LEVEL_COLORS: Record<WebErrorLevel | string, string> = {
  [WebErrorLevel.FATAL]: 'red',
  [WebErrorLevel.ERROR]: 'orange',
  [WebErrorLevel.WARNING]: 'gold',
  [WebErrorLevel.INFO]: 'blue',
};

/** 错误级别选项（用于下拉框） */
export const WEB_ERROR_LEVEL_OPTIONS = Object.entries(
  WEB_ERROR_LEVEL_LABELS,
).map(([value, label]) => ({
  value,
  label,
}));

// ============================================================================
// 性能指标类型标签
// ============================================================================

/** 性能指标类型标签映射 */
export const WEB_METRIC_TYPE_LABELS: Record<WebMetricType | string, string> = {
  [WebMetricType.PAGE_LOAD]: '页面加载',
  [WebMetricType.API_REQUEST]: 'API请求',
  [WebMetricType.RESOURCE]: '资源加载',
  [WebMetricType.WEB_VITALS]: 'Web核心指标',
  [WebMetricType.MEMORY]: '内存',
};

/** 性能指标类型选项（用于下拉框） */
export const WEB_METRIC_TYPE_OPTIONS = Object.entries(
  WEB_METRIC_TYPE_LABELS,
).map(([value, label]) => ({
  value,
  label,
}));

